/**
 * What the invoice prints about us. Kept here rather than inline in the PDF so
 * changing a phone number is one edit and not a hunt through layout code.
 *
 * The address matches the one the order invoice already prints — the two
 * documents go to the same buyers and must not disagree.
 */
const SELLER = {
  name: 'Elegant Tex',
  tagline: 'Raw Fabric Store · Wholesale Supply',
  lines: [
    'House 52, Lane 2, Block C, Ave No. 5',
    'Dhaka 1216, Bangladesh',
    '+8801896224057',
    'bd.eleganttex@gmail.com',
  ],
  terms:
    'Weights and roll counts are recorded at the time of loading; a line may carry weight with no whole roll against it where cut lengths are supplied. Claims on shade or weight must be raised within seven days of receipt, quoting this invoice number.',
};

export default SELLER;
